import { CircularProgress, ListItemIcon, ListItemText, MenuItem, useTheme } from "@mui/material";
import { MdsThumbDown } from "@sinch/icons";
import { enqueueSnackbar } from "notistack";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { MdsIcon } from "@sinch/components";
import { useApplicantStatus } from "@sinch/components/application/Applicant/useApplicantStatus";
import { useAttendanceUpdate } from "@sinch/components/application/Attendace/AttendanceUpdateProvider";

interface ApplicantRejectMenuItemProps {
  loading: boolean;
  handleClose: () => void;
  applicantId: string;
  onLoading?: (loading: boolean) => void;
}

export const ApplicantRejectMenuItem: FC<ApplicantRejectMenuItemProps> = ({
  loading,
  handleClose,
  applicantId,
  onLoading,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { declineApplicant } = useApplicantStatus();
  const trigger = useAttendanceUpdate();

  const handleKick = async () => {
    onLoading?.(true);
    try {
      const response = await declineApplicant(applicantId, null, true);
      if (response?.payload) {
        trigger?.([
          {
            positionId: response.payload.position.id,
            shiftId: response.payload.position.shift.id,
            workerId: response.payload.worker.id,
          },
        ]);
      }
    } catch (e) {
      console.error(e);
      enqueueSnackbar(t("Error.anErrorHasOccurred"), { variant: "error" });
    }
    onLoading?.(false);
    handleClose();
  };

  return (
    <MenuItem disabled={loading} onClick={handleKick} sx={({ palette }) => ({ color: palette.error.main })}>
      <ListItemIcon>
        {loading ? (
          <CircularProgress color="error" size={16} thickness={5} />
        ) : (
          <MdsIcon color="error" fontSize="small" icon={MdsThumbDown} sx={{ minWidth: "36px" }} />
        )}
      </ListItemIcon>
      <ListItemText primaryTypographyProps={{ color: theme.palette.error.main }}>{t("decline")}</ListItemText>
    </MenuItem>
  );
};
